/**
 *
 * @description: 华夏基金
 *
 */
import { isBuild } from '@/apis/host';
import { isThirdPartyMode, BridgeBase } from './bridge_utils';

const brmChannel = 'hxjj';
const comein_channel = isBuild ? '0d3416a5-a6c5-4083-95b2-4dbf53b67158' : '280d54ee-c807-4c26-abbd-aa3aaa29ae9e';

export const isThirdParty = isThirdPartyMode({ brmChannel, comein_channel });

if (isThirdParty) window.comeinChannel = 'hxjj';

// 华夏基金Bridge类 - 继承基类，可以重写或添加新方法
class Bridge extends BridgeBase {
  constructor() {
    super(brmChannel, false);
  }
}

// 导出实例作为默认导出（用于直接使用）
export default new Bridge();

export { Bridge };
